import {storeFromArea} from "./../../utils";

export const NEXT_PAGE = 'paging.nextPage'
export const PREV_PAGE = 'paging.prevPage'
export const HOME = 'paging.home'
export const END = 'paging.end'
export const GO_TO_PAGE = 'paging.goToPage'
export const SET_PAGE_SIZE = 'paging.setPageSize'
export const SET_ITEMS_COUNT = 'paging.setItemsCount'

export function is(action) {
    switch (action.type) {
        case NEXT_PAGE:
        case PREV_PAGE:
        case HOME:
        case END:
        case GO_TO_PAGE:
        case SET_PAGE_SIZE:
        case SET_ITEMS_COUNT:
            return true;
        default:
            return false;
    }
}

export function nextPage(area) {
    return {
        area,
        type: NEXT_PAGE,
    }
}

export function prevPage(area) {
    return {
        area,
        type: PREV_PAGE,
    }
}

export function home(area) {
    return {
        area,
        type: HOME,
    }
}

export function end(area) {
    return {
        area,
        type: END,
    }
}

export function goToPage(area, pageIndex) {
    return {
        area,
        type: GO_TO_PAGE,
        pageIndex,
    }
}

export function setPageSize(area, pageSize) {
    return {
        area,
        type: SET_PAGE_SIZE,
        pageSize,
    }
}

export function setItemsCount(area, itemsCount) {
    return {
        area,
        type: SET_ITEMS_COUNT,
        itemsCount,
    }
}

